<template>
  <v-row class="m-1 white rounded-lg justify-space-between">
    <v-col>
      <CreateTimerModal
        :formDate="dateDisplay"
        :disabled="timerControlsDisabled"
      />
    </v-col>
    <v-col>
      <v-card-text
        class="rounded-lg border text-center text-lg-h6 font-weight-bold"
        >{{ dateLLFormat }}
      </v-card-text>
    </v-col>
    <v-col class="text-right">
      <FabButtonCalendarPicker @calender-date-selected="gotoDate" />
    </v-col>
    <v-col v-if="showCopyButton" class="text-right">
      <v-btn
        fab
        @click="copyToClipBoardButtonPressed()"
        color="#2722a6"
        v-b-tooltip.hover
        title="Copy Logs to Clipboard"
      >
        <v-icon large color="white">mdi-clipboard-text-multiple</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import CreateTimerModal from "@/components/Timer/CreateTimerModal";
import FabButtonCalendarPicker from "@/components/Generic/FabButtonCalendarPicker";
import {customFormatDate} from "@/Utilites/timerHelper";

export default {
  name: "TimerPageToolBar",
  components: {
    FabButtonCalendarPicker,
    CreateTimerModal,
  },
  data() {
    return {
      calendarValue: "",
      pickerMenu: false,
    };
  },
  computed: {
    dateLLFormat() {
      return customFormatDate(this.dateDisplay, "LL");
    },
  },
  props: ["dateDisplay", "showCopyButton", "timerControlsDisabled"],
  methods: {
    copyToClipBoardButtonPressed() {
      this.$emit("copy-button-pressed");
    },
    gotoDate(calendarValue) {
      this.$emit("calendar-date-selected", calendarValue);
    },
  },
};
</script>

<style scoped></style>
